import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom'
import RegisterLoginButtons from 'modules/Common/components/RegisterLoginButtons';
import MyStableIcon from 'modules/Common/components/svg/MyStableIcon';
import InsiderIcon from 'modules/Common/components/png/InsiderIcon';
import { trackClick } from 'utils/AnalyticsUtils';
import { Link } from 'react-router';
import {INSIDERS_LINK_CLICK_TRACKING_EVENT} from 'modules/Common/consts';

import './InsiderBenefits.scss'

const LOGIN_TRACKING_ATTRIBUTES = trackClick(INSIDERS_LINK_CLICK_TRACKING_EVENT, {link: "[Insiders] Page Login"});
const REGISTER_TRACKING_ATTRIBUTES = trackClick(INSIDERS_LINK_CLICK_TRACKING_EVENT, {link: "[Insiders] Page Register"});

export default class InsiderBenefits extends Component {

  //component state and proptypes
  static propTypes = {
    loggedIn: PropTypes.bool.isRequired,
    userFirstName: PropTypes.string.isRequired,
    trackRegisterClick: PropTypes.func.isRequired,
    trackLoginClick: PropTypes.func.isRequired
  }

  state = {
    articleHeight: 0,
    footerClass: '',
    scrollEvents: ['scroll', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll', 'resize', 'touchmove', 'touchend'],
    benefitItems: [
      {
        title: "Horse racing video replays",
        content: "Unlimited video replays Watch race replays from all Sky Sports Racing and Racing TV tracks, from 30 minutes after the race.",
        skycon: 0xF04A,
        url: "/racing/results"
      },
      {
        title: "Expert Tips and Previews",
        content: "Exclusive access to leading analysis, previews, and tips from our top columnists.",
        skycon: 0xF711,
        url: "/racing/tips-centre"
      },
      {
        title: "My Stable",
        content: "Keep track of all of your selected horses with email reminders the night before they're due to run.",
        icon: <MyStableIcon className="insider-icon" title="My Stable" key="icon" />,
        url: "/racing/my-stable"
      },
      {
        title: "Exclusive Offers",
        content: "Take advantage of exclusive offers and promotions at our partner betting site, Sky Bet.",
        skycon: 0xF0D2,
        url: "/"
      },
      {
        title: "Live Score Notifications",
        content: "Never miss a goal with live score notifications straight to your phone on all football matches.",
        skycon: 0xF406,
        url: "/football/live"
      },
      {
        title: "Enter ITV7",
        content: "Use your Insider account to enter ITV7, the free to enter competition with a huge cash prize.",
        skycon: 0xF302,
        url: "https://itv7.itv.com"
      }
    ]
  }

  //life cycle events
  componentDidMount() {
    this.attachStickyFooter()
  }

  componentWillUnmount() {
    this.state.scrollEvents.forEach(event => {
      if(window.removeEventListener) {
        window.removeEventListener(event, this.onScroll, false)
      } else {
        window.detachEvent(`on${event}`, this.onScroll, false)
      }
    })
  }

  attachStickyFooter = () => {
    this.state.scrollEvents.forEach(event => {
      if (window.addEventListener) {
        window.addEventListener(event, this.onScroll, false)
      } else {
        window.attachEvent(`on${event}`, this.onScroll, false)
      }
    })
  }

  onScroll = () => {
    const article = findDOMNode(this.refs.insiderArticle)
    const articleBondingRect = article.getBoundingClientRect()
    const articlePosition = ~(articleBondingRect.top) + window.innerHeight - 123
    const articleFooterNode = findDOMNode(this.refs.insiderArticleFooter);
    const articleFooterHeight = articleFooterNode ? articleFooterNode.offsetHeight : 0

    if(this.state.articleHeight === 0) {
      this.setState({...this.state, articleHeight: article.offsetHeight})
    }

    if (articlePosition > (this.state.articleHeight - articleFooterHeight)+100) {
      this.setState({...this.state, footerClass: 'unstick'})
      return 
    }

    if (articlePosition < (this.state.articleHeight  + articleFooterHeight)) {
      this.setState({...this.state, footerClass: ''})
      return 
    }
  }


  //render template helpers

  getArticleTitle = (loggedIn, userFirstName) => {
    if (loggedIn && userFirstName) {
      return <h1><span>Welcome to Insiders, {userFirstName[0].toUpperCase() + userFirstName.substring(1)}.</span></h1>
    }
    return <h1><span>Know it all.</span></h1>
  }

  getFeaturesSubTitle = loggedIn => loggedIn ? "As an Insider, make the most of..." : "What you get (it's all FREE)"

  getFeaturesTagLine = loggedIn => {
    if (loggedIn) {
      return <div className="tag-line">
          <p>Access features and exclusive promotions you won’t find anywhere else! Check back here to see the latest offers and features, exclusively for <b>Insiders</b>.</p>
        </div>
    }
    return <div className="tag-line">
        <p>All you need to do to become an <InsiderIcon title="Insiders" color="blue" /><strong>Insider</strong> is log in - it's that simple.</p>
        <p>Log in with your existing <strong>Sporting Life, Sky Bet</strong>, or <strong>Sky Games</strong> account. If you don't have any of those, it's completely free to register!</p>
      </div>
  }

  render() {
    return (
      <article ref="insiderArticle" className="insider-benefits">
      <header className="insider-header">
        { this.getArticleTitle(this.props.loggedIn, this.props.userFirstName) }
        { !this.props.loggedIn &&
          <p><span>Log in or register now for FREE and UNLIMITED access to ALL Sporting Life features.</span></p>
        }
      </header>
      <section className="insider-features">
        <header className="insider-features-header">
          { this.getFeaturesTagLine(this.props.loggedIn) }
          { !this.props.loggedIn &&
            <section className="insider-cta-login">
              <RegisterLoginButtons 
                trackLoginClickAttributes={LOGIN_TRACKING_ATTRIBUTES}
                trackRegisterClickAttributes={REGISTER_TRACKING_ATTRIBUTES}
                registerClick={this.props.trackRegisterClick} 
                loginClick={this.props.trackLoginClick}
                registerLabel={"Join for free"} />
            </section>
          }
          <h2>{ this.getFeaturesSubTitle(this.props.loggedIn) }</h2>
        </header>
        <ul>
          { this.state.benefitItems.map((benefit, key) => BenefitItemComponent({...benefit, key, loggedIn: this.props.loggedIn})) }
        </ul>
      </section>
      <section className="insider-extra">
        <header>
          <h2>Plus</h2>
          <p>Access to all your favourite free-to-enter competitions.</p>
        </header>
        <span>
          <img key="1" src="/img/insider-benefit-logos/itv-racing.png"/>
          <img key="2" src="/img/insider-benefit-logos/super6.png"/>
          <img key="3" src="/img/insider-benefit-logos/fantasyfootball.png"/>
          <img key="4" src="/img/insider-benefit-logos/six-a-side.png"/>
        </span>
      </section>
      { !this.props.loggedIn &&
        <footer ref="insiderArticleFooter" className={this.state.footerClass}>
          <h2> Know it all - become an Insider</h2>
          <RegisterLoginButtons
            trackLoginClickAttributes={LOGIN_TRACKING_ATTRIBUTES}
            trackRegisterClickAttributes={REGISTER_TRACKING_ATTRIBUTES}
            registerClick={this.props.trackRegisterClick} 
            loginClick={this.props.trackLoginClick}
            registerLabel={"Join for free"} />
        </footer>
      }
    </article>
    )
  }
}

function BenefitItemComponent({ title="", content = "", key=0, skycon, icon, url, loggedIn }) {
  require('./BenefitItem.scss');

  let children = [
    <h3 key="title" className="detail-title">{ title }</h3>,
    <p key="desc" className="detail-content">{ content }</p>,
  ];

  if (icon) {
    children.unshift(icon);
  }

  if (skycon) {
    children.unshift(<span key="skycon" className="skycon insider-icon" title={ title }>{String.fromCharCode(skycon)}</span>);
  }

  if (loggedIn) {
    if (url.indexOf('http') === 0) {
      children = <a href={url}>{children}</a>
    } else {
      children = <Link to={url}>{children}</Link>
    }
  }

  return (
    <li key={ key } className="insider-benefit-item">
      {children}
    </li>
  )
}

BenefitItemComponent.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  key: PropTypes.number.isRequired,
  loggedIn: PropTypes.bool,
  skycon: PropTypes.string,
  icon: PropTypes.object,
  url: PropTypes.string
};



// WEBPACK FOOTER //
// ./modules/Insider/components/InsiderBenefits.js